/** @format */
import { MvnoBlockFunctionsCollection } from '../../block/BlockContainHelper';
import { useDispatch, useSelector } from 'react-redux';
import { BlockActions, BlockReducerType } from '../../block/blockReducers';
import { useEffect } from 'react';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';

export const useBlockFunctionList = (): MvnoBlockFunctionsCollection | null => {
    const dispatch = useDispatch();
    const { blockFunctions } = useSelector((state: { blockReducers: BlockReducerType }) => state.blockReducers);

    useEffect(() => {
        if (!blockFunctions) {
            const itemLoaders = new ItemLoaders(dispatch);
            itemLoaders.getListWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/mvno_block_functions')),
                BlockActions.BLOCK_FUNCTION_LIST_LOAD,
                [
                    { name: 'deleted', value: false },
                    { name: 'allowed', value: true },
                ],
                [{ name: 'displayName', value: 'asc' }],
                (data: MvnoBlockFunctionsCollection): void => {
                    dispatch({
                        type: BlockActions.BLOCK_FUNCTION_LIST_LOAD,
                        blockFunctions: data,
                    });
                },
                { propagateDataToCallback: true, dispatchAfterCallback: false }
            );
        }
    }, [blockFunctions, dispatch]);

    return blockFunctions ?? null;
};
